import React from 'react'
import OrangeOpaskaSales from '../components/dashboard/orange-opaska/OrangeOpaskaSales'

const OrangeOpaskaSalesPage = () => <OrangeOpaskaSales />

export default OrangeOpaskaSalesPage
